import axios from "axios"
let api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_STRAPI_API_URL,
  headers: {
    Accept: "application/json"
  }
})

api.interceptors.request.use(request => {
  return request
})

api.interceptors.response.use(
  response => {
    return response
  },
  function (error) {
    console.log("Api Response Error: ", error)
    return Promise.reject(error)
  }
)

export default api
